import React, { useEffect, useContext } from 'react';
import Heading from 'components/common/heading/heading';
import Flow from 'components/common/flow/flow';
import SiteContext from 'components/shared/siteContext/siteContext';
import Panel from 'components/common/panel/panel';
import AppContext from 'contexts/appContext';
import { Tabs, Tab } from 'react-bootstrap';
import Datatable from 'components/common/datatable/datatable';
import './siteManagerPage.css';

export default function SiteManagerPage(props) {
  const { setAppArea, setAppBreadcrumb } = useContext(AppContext);

  useEffect(() => {
    setAppArea(AppContext.Areas.BackofficeReports, 'Manage Site');
    setAppBreadcrumb([{ name: 'Home', href: '/' }, { name: 'Site Details', href: '/SiteAttributeViewer' }, { name: 'Manage Site', selected: true }]);
  }, []);

  return (
    <Flow>
      <Flow.Header>
        <Heading>
          <SiteContext.Button hierarchyId={141} />
        </Heading>
      </Flow.Header>

      <Flow.Body>
        <div className='row justify-content-md-center mx-0 mt-4'>
          <div className='col-12 col-md-10 col-xl-8'>
            <div className='d-flex justify-content-between align-items-center w-100'>
              <h3>Richard's Pub</h3>
              <h6>Store</h6>
            </div>
            <hr />
            <Tabs className='main-tabs' defaultSelection='software' id='site-manager-main'>
              <Tab value='site' title='Site'>
                <Site />
              </Tab>
              <Tab value='software' title='Software'>
                <Software />
              </Tab>
              <Tab value='users' title='Users'>
                <Users />
              </Tab>
            </Tabs>
          </div>
        </div>
      </Flow.Body>
    </Flow>
  );
}

function Site() {
  return (
    <div>
      Site
    </div>
  );
}

function Software() {
  const SoftwareInstalled = (props) => {
    const SoftwareInstalledRow = (item, index, history) => {
      const onItemClicked = () => {
        //history.push(`/SoftwareUpdateManifest/${item.hierarchyId}`);
      };

      return (
        <li className='list-group-item' onClick={onItemClicked}>
          <div className='d-flex justify-content-between align-items-center w-100'>
            <div style={{ fontWeight: 600 }}>{item.softwareName}</div>
            <div>
              <span className='badge badge-light-success badge-md'>{item.versionName}</span>
            </div>
          </div>
        </li>
      );
    };

    return (
      <Panel>
        <Panel.Header>Installed Software</Panel.Header>
        <Panel.Body active='true'>
          <ul className='list-group list-group-flush'>
            {SoftwareInstalledRow({ softwareName: 'SpcWin', versionName: '6.41.0' }, 0, props.history)}
            {SoftwareInstalledRow({ softwareName: 'QuickMenu', versionName: '2.6.9.24' }, 0, props.history)}
            {SoftwareInstalledRow({ softwareName: 'POSipay', versionName: '1.5.6.34567' }, 0, props.history)}
          </ul>
        </Panel.Body>
      </Panel>
    );
  };

  const SoftwareRecentUpdates = (props) => {
    const SoftwareRecentUpdatesRow = (item, index, history) => {
      const onItemClicked = () => {
        //history.push(`/SoftwareUpdateManifest/${item.hierarchyId}`);
      };

      return (
        <li className='list-group-item' onClick={onItemClicked}>
          <div className='d-flex justify-content-between align-items-center w-100'>
            <div style={{ fontWeight: 600 }}>{item.softwareName}</div>
            <div>
              <span className='badge badge-light-secondary badge-md'>{item.versionName}</span>
            </div>
          </div>
        </li>
      );
    };

    return (
      <Panel>
        <Panel.Header>Recent Updates</Panel.Header>
        <Panel.Body active='true'>
          <ul className='list-group list-group-flush'>
            {SoftwareRecentUpdatesRow({ softwareName: 'POSipay', versionName: '1.5.8.21454' }, 0, props.history)}
          </ul>
        </Panel.Body>
      </Panel>
    );
  };

  return (
    <Tabs className='sub-tabs mt-3' defaultSelection='installed' id='site-manager-software'>
      <Tab value='installed' title='Installed Software'>
        <SoftwareInstalled />
      </Tab>
      <Tab value='available' title='Available Software'>
        Available Software...
      </Tab>
      <Tab value='recent' title='Recent Updates'>
        <SoftwareRecentUpdates />
      </Tab>
    </Tabs>
  );
}

function Users() {
  return (
    <Panel>
      <Panel.Header>Users</Panel.Header>
      <Panel.Body>
        <Datatable columns={UsersTableColumns} data={UsersTableData} maxHeight={300} />
      </Panel.Body>
    </Panel>
  );
}

const UsersTableColumns = [
  {
    Header: 'User Id',
    accessor: 'loginName',
    width: 250,
    textAlign: 'left',
  },
  {
    Header: 'Password?',
    accessor: 'isUserPassword',
    width: 250,
    align: 'left',
  },
  {
    Header: 'Locked Out?',
    accessor: 'isUserLockedOut',
    width: 250,
    align: 'center',
  },
  {
    Header: 'Setup Complete?',
    accessor: 'isUserSetup',
    width: 250,
    align: 'right'
  }
];

const UsersTableData = [
  {
    loginName: 'User 1',
    isUserPassword: 'true',
    isUserSetup: 'true',
    isUserLockedOut: 'false'
  },
  {
    loginName: 'User 2',
    isUserPassword: 'true',
    isUserSetup: 'false',
    isUserLockedOut: 'false'
  },
  {
    loginName: 'User 3',
    isUserPassword: 'true',
    isUserSetup: 'true',
    isUserLockedOut: 'false'
  },
  {
    loginName: 'User 4',
    isUserPassword: 'true',
    isUserSetup: 'true',
    isUserLockedOut: 'false'
  },
  {
    loginName: 'User 5',
    isUserPassword: 'true',
    isUserSetup: 'false',
    isUserLockedOut: 'false'
  },
  {
    loginName: 'User 6',
    isUserPassword: 'true',
    isUserSetup: 'true',
    isUserLockedOut: 'false'
  },
  {
    loginName: 'User 7',
    isUserPassword: 'true',
    isUserSetup: 'true',
    isUserLockedOut: 'false'
  },
  {
    loginName: 'User 8',
    isUserPassword: 'true',
    isUserSetup: 'false',
    isUserLockedOut: 'false'
  },
  {
    loginName: 'User 9',
    isUserPassword: 'true',
    isUserSetup: 'true',
    isUserLockedOut: 'false'
  },
  {
    loginName: 'User 10',
    isUserPassword: 'true',
    isUserSetup: 'true',
    isUserLockedOut: 'false'
  },
  {
    loginName: 'User 11',
    isUserPassword: 'true',
    isUserSetup: 'true',
    isUserLockedOut: 'false'
  },
  {
    loginName: 'User 12',
    isUserPassword: 'true',
    isUserSetup: 'true',
    isUserLockedOut: 'false'
  }
];

const StoresGridColumns = [
  {
    Header: 'Site',
    accessor: 'hierarchyName',
    minWidth: 250,
    textAlign: 'left',
    sticky: 'left',
  },
  {
    Header: 'License Key',
    accessor: 'licenseKey',
    minWidth: 160,
    textAlign: 'right',
  },
  {
    Header: 'License Mode',
    accessor: 'licenseMode',
    minWidth: 250,
    textAlign: 'center',
  },
  {
    Header: 'License Status',
    accessor: 'licenseStatus',
    minWidth: 250,
    textAlign: 'center',
  },
  {
    Header: 'Hardware Signature',
    accessor: 'hwSignature',
    minWidth: 250,
    textAlign: 'left',
  }
];

const StoresGridData = [
  {
    hierarchyName: 'Richard\'s Pub',
    licenseKey: '15144',
    licenseMode: 'PC License',
    licenseStatus: 'No Error',
    hwSignature: '0AFB90FB3E9A6548'
  },
  {
    hierarchyName: 'Site 1',
    licenseKey: '13243',
    licenseMode: 'HW Key',
    licenseStatus: 'No Error',
    hwSignature: '0AFB90FB3E9A6548'
  },
  {
    hierarchyName: 'DQ #24565',
    licenseKey: '65435',
    licenseMode: 'PC License',
    licenseStatus: 'No Error',
    hwSignature: 'fwetgwregwregfwdsref'
  },
  {
    hierarchyName: 'DQ #7453',
    licenseKey: '213123',
    licenseMode: 'PC License',
    licenseStatus: 'No Error',
    hwSignature: 'fwedfdesafds'
  },
  {
    hierarchyName: 'DQ #123545',
    licenseKey: '-',
    licenseMode: '-',
    licenseStatus: '-',
    hwSignature: 'fdsfdsvsdvdsfa'
  },
  {
    hierarchyName: 'DQ #978554',
    licenseKey: '412321',
    licenseMode: 'PC License',
    licenseStatus: 'No Error',
    hwSignature: 'fdsafdsafewewfds'
  },
  {
    hierarchyName: 'DQ #123454',
    licenseKey: '43133',
    licenseMode: 'PC License',
    licenseStatus: 'No Error',
    hwSignature: 'hgfsdhfgfdsgdsgag'
  },
  {
    hierarchyName: 'DQ #3238',
    licenseKey: '2133321',
    licenseMode: 'PC License',
    licenseStatus: 'No Error',
    hwSignature: 'nfe3urhfewqiunbfqdw'
  }
];
